// Display-only labels for the "Compare" feature, renamed to "Reconciliation" in
// the UI. These map STORED values → visible text; the stored category /
// subCategory strings ("Compare", "File to Database", …) are unchanged in state,
// payloads, and records. Anything unmapped falls through to the raw value.
export const CATEGORY_LABEL = {
  Compare: "Reconciliation",
};

export const SUBCATEGORY_LABEL = {
  "File to Specification": "File → Specification",
  "File to Database": "File → Database",
  "File to File": "File → File",
  "Database to Database": "Database → Database",
};

export const labelForCategory = (v) => CATEGORY_LABEL[v] ?? v;
export const labelForSubCategory = (v) => SUBCATEGORY_LABEL[v] ?? v;
